export const FormateNumberWithCommas = (num: string): string => {
  if (!num) return '0';
  return Number(num).toLocaleString('en', {
    maximumFractionDigits: 2,
  });
};
